export const eventHandler = (handler, ...props) => (e) => {
  e.preventDefault();
  e.stopPropagation();
  if (handler) {
    handler(...props);
  }
};


// WEBPACK FOOTER //
// ./src/utils/form.js